import { gatewayApi } from './api';
import {
  balancesFromPortfolio,
  positionsFromPortfolio,
  resolveCustomerPortfolio,
} from '../components/portfolio/portfolioModel';

const unwrap = (response) => response.data?.data ?? response.data;

export const portfolioService = {
  /**
   * Consolidated customer portfolio: positions, cash balances, and valuation.
   * Optional displayCurrency is an ISO 4217 code; omit it to use the account currency.
   */
  async getCustomerPortfolio(customerId, { displayCurrency } = {}) {
    const params = {};
    if (displayCurrency) params.displayCurrency = displayCurrency;
    const response = await gatewayApi.get(`/v1/portfolio/customers/${customerId}`, { params });
    return unwrap(response);
  },

  /**
   * Same portfolio as getCustomerPortfolio, but accepts a users-list record
   * whose customerId, userId, and id are not the same value. Returns the id
   * that the gateway accepted plus the unwrapped portfolio payload.
   */
  async getCustomerPortfolioResolved(customerOrId, options) {
    return resolveCustomerPortfolio(
      (customerId, opts) => this.getCustomerPortfolio(customerId, opts),
      customerOrId,
      options,
    );
  },

  // Order placement still calls these names. Both read the consolidated portfolio.
  async getPositions(customerId, options) {
    const portfolio = await this.getCustomerPortfolio(customerId, options);
    return positionsFromPortfolio(portfolio);
  },

  async getBalances(customerId, options) {
    const portfolio = await this.getCustomerPortfolio(customerId, options);
    return balancesFromPortfolio(portfolio);
  },

  async getHistory(customerId, period = '1w') {
    const response = await gatewayApi.get(`/v1/portfolio/customers/${customerId}/history`, {
      params: { period },
    });
    return unwrap(response);
  },

  async getOrgSummary() {
    const response = await gatewayApi.get('/v1/portfolio/summary');
    return unwrap(response);
  },
};

export default portfolioService;
